import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import './styles.css'
import Item from './item'
import { sagaGetOfertas } from '../../reducers/OfertaReducer/actions'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

/*
const styles = theme => ({
    root:{
      zIndex: 1200,
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      boxShadow: '-5px 4px 10px #8E8E8E29',
      borderRadius: '21px',
      opacity: 1,
      padding: '0px !important',
      minWidth: '300px'
    },
    rootDialog:{
        zIndex: 1250,
    },
  })

*/

const Oferta = (props) => {
    const dragItem = useRef();
    const dragOverItem = useRef();
    const [itemsOfertas, setItemsOfertas] = useState([]);

    React.useEffect(() => {
        setItemsOfertas(props.ofertas);
    }, [props.ofertas])

    const dragStart = (e, position) => {
        dragItem.current = position;
        console.log(e.target.innerHTML);
    };

    const dragEnter = (e, position) => {
        dragOverItem.current = position;
        console.log(e.target.innerHTML);
    };

    const drop = (e) => {
        const copyListItems = [...itemsOfertas];
        const dragItemContent = copyListItems[dragItem.current];
        const dragOverItemContent = copyListItems[dragOverItem.current];
        copyListItems.splice(dragItem.current, 1); //se borra
        copyListItems.splice(dragItem.current, 0, dragOverItemContent);
        copyListItems.splice(dragOverItem.current, 1); //se borra
        copyListItems.splice(dragOverItem.current, 0, dragItemContent);
        dragItem.current = null;
        dragOverItem.current = null;

        props.handleOnSwap(
            copyListItems.map(
                (x) => x.idOferta.toString()
            )
        )

        setItemsOfertas(copyListItems);
    };

    return (
        <>
            {/* menú superior */}
            <TitleBar
                title={'Ofertas'}
                newButtonLink='/Oferta/Nuevo'
            />

            <Row style={{ margin: '0px' }} className='draggable'>
                {
                    itemsOfertas &&
                    itemsOfertas.map((item, index) => (
                        <Col
                            md={6} lg={4}
                            onDragStart={(e) => dragStart(e, index)}
                            onDragEnter={(e) => dragEnter(e, index)}
                            onDragEnd={drop}
                            key={index}
                            className='draggable'
                            draggable>
                            <Item item={item} {...props}></Item>
                        </Col>
                    ))}
            </Row>
            {(props.contenidos === undefined || props.contenidos.length === 0) &&
                <div className='noOfertas'>No se encontraron ofertas activas</div>
            }


            {/* CONFIRMAR BORRAR */}
            {(props.itemABorrar !== undefined) &&
                <Dialog
                    //classes={{root: classes.rootDialog, paperScrollPaper: classes.root}}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth='sm'
                    open={props.openModalBorrar}
                    fullWidth={true}
                >
                    <DialogContent /*classes={{root: classes.root}}*/>


                        <Row style={{ margin: '0px' }}>


                            <Col xs={12} md={12} lg={12} style={{ padding: '0px' }}>
                                <div className='containerModalVer'>
                                    <div className='titleModal'>{`Estás por borrar la oferta ${props.itemABorrar.nombre}`}</div>


                                    <div className='containerButtonsModal'>
                                        <Button className='btnCerrarModalFlat' onClick={props.handleOnClickCerrarModal}>
                                            CANCELAR
                                        </Button>
                                        <Button className='btnBorrarModal' onClick={() => { props.handleOnClickBorrar(undefined, true) }}>
                                            BORRAR
                                        </Button>
                                    </div>
                                </div>
                            </Col>

                        </Row>


                    </DialogContent>
                </Dialog>}
        </>
    );

}

Oferta.propTypes = {
    ofertas: PropTypes.array.isRequired,
    openModalVer: PropTypes.bool,
    openModalBorrar: PropTypes.bool,
    handleOnClickVer: PropTypes.func.isRequired,
    handleOnClickEditar: PropTypes.func.isRequired,
    handleOnClickBorrar: PropTypes.func.isRequired,
    handleOnClickCerrarModal: PropTypes.func.isRequired,
    handleOnSwap: PropTypes.func.isRequired,
}

Oferta.defaultProps = {
    ofertas: [],
    canSwap: true,
    openModalVer: false,
    handleOnClickVer: f => f,
    handleOnClickEditar: f => f,
    handleOnClickBorrar: f => f,
    handleOnClickCerrarModal: f => f,
    handleOnSwap: f => f,
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        sagaGetOfertas
    }, dispatch)
}

export default connect(mapDispatchToProps)(Oferta)